import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { JobAddress } from './styled';

export const mapStateToProps = ({ designPro }) => ({
  jobDetails: designPro.app.jobDetails,
});

export class FooterAddress extends PureComponent {
  static propTypes = {
    jobDetails: PropTypes.object.isRequired,
  };

  static defaultProps = {
    jobDetails: {
      location_line_1: '',
    },
  };

  render() {
    const {
      jobDetails: { location_line_1 },
    } = this.props;
    return (
      <JobAddress data-selenium="footerAddressText">
        {location_line_1}
      </JobAddress>
    );
  }
}

export default connect(mapStateToProps)(FooterAddress);
